<template>
  <div>
    <div class="relative" :class="imageUrl ? '' : colorThemeBg" :style="imageBg">
      <div v-if="useOverlay && imageUrl" class="absolute w-full h-full bg-overlay-gradient"></div>
      <div class="flex flex-col gap-12 py-16 overflow-hidden md:gap-10 container-small md:relative md:flex-row" :class="alignBoxCenter ? ' items-center justify-center' : 'justify-between'">
        <!-- Pictorgram mobile -->
        <div v-if="!alignBoxCenter && !imageUrl" class="self-center w-[12.5rem] md:hidden">
          <ellevio-web-icon-pictogram :type-pictogram="typePictogram" :color-pictogram="colorThemePictogram" />
        </div>

        <!-- Call To Action Box -->
        <div class="box-border relative z-30 flex flex-col gap-8 px-6 py-8 bg-white half-area rounded-xl shadow-mp" :class="alignBoxCenter ? 'text-center items-center' : 'items-start'">
          <!-- Pictogram inside box -->
          <ellevio-web-icon-pictogram v-if="alignBoxCenter" :type-pictogram="typePictogram" :color-pictogram="colorThemePictogram" class="w-[7.375rem] mx-auto" />

          <div class="flex flex-col gap-4">
            <h2 class="text-3xl md:text-5xl font-futuraEfDemiBold text-newColors-gray-content">{{ ctaBlock.headerText }}</h2>
            <p class="text-xl text-newColors-gray-contentA font-futuraEfBook">{{ ctaBlock.paragraphText }}</p>
          </div>
          <a :href="ctaBlock.linkUrl" class="cursor-pointer btn-primary" data-testid="callToActionBlockLink">{{ ctaBlock.linkText }}</a>
          <!-- Company label -->
          <p v-if="company" class="px-3 py-1 text-base rounded-lg font-futuraEfBook text-newColors-gray-contentA" :class="companyStyle">{{ company }}</p>
        </div>

        <!-- Pictorgram desktop -->
        <div v-if="!alignBoxCenter && !imageUrl" class="relative items-center justify-center flex-1 hidden md:flex">
          <ellevio-web-icon-pictogram :type-pictogram="typePictogram" :color-pictogram="colorThemePictogram" class="absolute w-[33.75rem] z-10" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import EllevioWebIconPictogram from '@/stories/web/vue-components/IconPictogram.vue'
import { computed } from 'vue'

const props = defineProps({
  ctaBlock: {
    type: Object,
    default: () => ({
      headerText: '',
      paragraphText: '',
      linkUrl: '#',
      linkText: ''
    })
  },
  alignBoxCenter: {
    type: Boolean,
    default: false
  },
  company: {
    type: String,
    default: ''
  },
  typePictogram: {
    type: String,
    default: ''
  },
  colorTheme: {
    type: String,
    default: 'PrimaryA'
  },
  useOverlay: {
    type: Boolean,
    default: false
  },
  imageUrl: {
    type: String,
    default: ''
  }
})

// Color theme
const colorThemeBg = computed(() => {
  if (props.colorTheme === 'PrimaryA') return 'bg-newColors-green-primaryA'
  if (props.colorTheme === 'Primary') return 'bg-newColors-green-primaryB'
  if (props.colorTheme === 'Signature') return 'bg-newColors-orange-signatureB'
  if (props.colorTheme === 'SecondaryA') return 'bg-newColors-orange-secondaryB'
  if (props.colorTheme === 'SecondaryC') return 'bg-newColors-green-secondaryC'
  if (props.colorTheme === 'ContentA') return 'bg-newColors-gray-baseB'
  return ''
})

const colorThemePictogram = computed(() => {
  if (props.colorTheme === 'PrimaryA' && props.alignBoxCenter === true) return '#0B8454'
  if (props.colorTheme === 'PrimaryA' && props.alignBoxCenter === false) return '#ffffff'
  if (props.colorTheme === 'Primary') return '#0B8454'
  if (props.colorTheme === 'Signature') return '#FF8300'
  if (props.colorTheme === 'SecondaryA') return '#AAA672'
  if (props.colorTheme === 'SecondaryC') return '#87C8B9'
  if (props.colorTheme === 'ContentA') return '#363433'
  return ''
})

// Image background
const imageBg = computed(() => {
  if (props.imageUrl) return `background-image: url('${props.imageUrl}'); background-repeat: no-repeat; background-size: cover; background-position: center;`
  else return ''
})

// Company style
const companyStyle = computed(() => {
  if (props.company === 'Ellevio' || props.company === 'Ellevio Energy Solutions AB') return 'bg-newColors-orange-secondaryB'
  else return 'bg-newColors-gray-background'
})
</script>

<style scoped>
.half-area {
  width: 100%;
}

@media (min-width: 768px) {
  .half-area {
    width: calc(50% - 1.5rem);
  }
}
</style>
